import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDto } from '@bo-client/shared/models/userDto';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { RequestModel } from '@bo-client/shared/models/request.model';

@Component({
  selector: 'app-detail-page-header-actions',
  templateUrl: './detail-page-header-actions.component.html',
  styleUrls: ['./detail-page-header-actions.component.scss']
})
export class DetailPageHeaderActionsComponent implements OnInit {
  @Input() model: RequestModel;
  @Input() user: UserDto;
  @Output() onActionClickedEvent = new EventEmitter<any>();

  @Input()
  actions: ActionWithMoreInfoModel[] = [];

  hasRole(roles: string[]) {
    return this.user.roles.find((x) => roles.includes(x.name)) != undefined;
  }

  ngOnInit(): void {}

  public showActionButton(action: ActionWithMoreInfoModel) {
    return action.visibleCondition(this.model, this.model.state, this.user);
  }

  public disableButton(action: ActionWithMoreInfoModel) {
    if (action.disabled) {
      return action.disabled(this.user);
    } else {
      return false;
    }
  }

  onButtonClicked(action: ActionWithMoreInfoModel) {
    this.onActionClickedEvent.emit(action);
  }
}
